import React from "react";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const CustomButton = ({ text }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const applySpecialDesign =
    location.pathname.startsWith("/industries") ||
    location.pathname.startsWith("/services");

  return (
    <Button
      variant="contained"
      onClick={() => navigate("/contact")}
      sx={{
        backgroundColor: applySpecialDesign ? "#FFFFFF33" : "#102566",
        color: "#fff",
        padding: "16px 24px",
        borderRadius: applySpecialDesign ? "4px" : "30px",
        textTransform: "none",
        border: applySpecialDesign ? "1px solid #FFFFFF33" : "none",
        fontFamily: "Source Sans 3",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "100%",
        letterSpacing: "0%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {text}
      <img
        src="/assets/icons/RightArrow.svg"
        alt="arrow"
        style={{ width: "18px", height: "18px" }}
      />
    </Button>
  );
};

export default CustomButton;
